import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';

import find from 'lodash/find'

import * as deleteSubDecision from '../../../actions/decisiondetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class DeleteSubDecision extends Component {
    state = {
        setPostValue: false,
    };

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        if (this.props.data.id && this.props.data.id > 0) {
            this.props.actions.deleteSubDecisionDetails(Number(this.props.data.id), this.props.decision_id);
            this.setState({ setPostValue: true })
        }
        else
            this.deleteSubDecision();
    };

    deleteSubDecision() {
        this.props.setDeleteSubDecision();
        this.props.closeDialog();
        this.setState({ setPostValue: false })
    }
    render() {
        const { id, decisionDetails } = this.props;
        let result = null;
        if (decisionDetails && decisionDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (decisionDetails && !decisionDetails.Status && decisionDetails.apiPostResult && this.state.setPostValue) {
            this.deleteSubDecision();
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Delete Sub Decision</span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row p-4">
                            <div className="col-md-12">
                                Do you want to delete the Sub Decision Details?
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Delete</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(deleteSubDecision, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DeleteSubDecision);


// WEBPACK FOOTER //
// ./app/decisiondetails/adddecision/deletesubdecision.js